/**
 * Whether a work order in the given status may have a More Information Request
 * (MIR) raised or replied to by the user.
 *
 * MIR is not a valid action on a closed/terminal work order. This mirrors CORE,
 * where the "Provide Information" action is hidden once a work order is
 * Completed, Rejected, Cancelled, or Validated (WRK-5644). Comparison is
 * case-insensitive to match how statuses are normalised elsewhere in the domain.
 */
const TERMINAL_STATUSES: ReadonlyArray<string> = [
  'Completed',
  'Rejected',
  'Cancelled',
  'Validated',
];

export function canRequestMoreInfo(workOrderStatus: string): boolean {
  const normalized = workOrderStatus.trim().toLowerCase();
  return !TERMINAL_STATUSES.some((s) => s.toLowerCase() === normalized);
}
